export default __webpack_public_path__ + "b290682be1a7840c352e28767ccb657b.png";